export const onlyNumbers = txt => `${txt}`.replace(/[^\d]/g, '')
export const onlyAlphaNumeric = txt => `${txt}`.replace(/[^a-z0-9]/gi, '')
export const removeAccents = txt => txt.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
